import { useEffect } from "react";

import { useRouter } from "next/router";

import { useFeature } from "shared/utils/hooks/useFeature";

const useHandleGroupFeatureFlag = () => {
  const isGroupsEnabled = useFeature("f_groups");
  const { push } = useRouter();

  useEffect(() => {
    if (!isGroupsEnabled) push("/404");
  }, [isGroupsEnabled, push]);

  return {};
};

export default useHandleGroupFeatureFlag;
